import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { navigate } from 'gatsby';
import Button from '~/components/atoms/Button'
import HelpFeatures from '~/components/molecules/HelpFeatures'
import { rentalCtaLabels } from '~/data/translations/rentalCtaLabels';
import './custom-reviews-banner.css';

export default function RentalCta({ isHero, className, subheadingClassName, subheading, heading, showHelpFeatures = false, language = 'en' }) {
  const [value, setValue] = useState('');

  const labels = rentalCtaLabels[language];

  const redirects = {
    "en": "/pricing/",
    "fr": "/fr/estimation-de-location-a-paris/",
    "es": "/es/estimacion-de-alquiler-en-barcelona/",
  }

  return (
    <div className={`${className}`}>
      <h6 className={`text-h6 mb-4 ${subheadingClassName}`}>{subheading}</h6>
      <h4 className="text-h2 mb-6">{heading}</h4>

      <form
        className="flex flex-col sm:flex-row input-postcode"
        onSubmit={e => {
          e.preventDefault();
          navigate(`${redirects[language]}`);
        }}
      >
        <input value={value} onChange={e => setValue(e.target.value)} type="text" placeholder={labels.postcode} className="bg-white px-5 py-4 md:py-6 w-full outline-none text-navy postcode-input" />
        <Button type="button" title={labels.buttonLabel} className="inline-flex items-center whitespace-nowrap get-rental-estimate-btn" />
      </form>

      {
        showHelpFeatures && (
          <HelpFeatures language={language ?? 'en'} />
        )
      }

      {isHero && (
        <div id="custom-reviews-banner">
          <label>
            Rated <b>4.7</b> / 5 based on <b>2,035 reviews</b>. Showing our favourite reviews.
          </label>
          <br></br>
          <StaticImage
            src={'../../assets/images/tp-logo.png'}
            className="responsive-img"
            alt="CityRelay" />
        </div>
      )}

    </div >
  )
}
